import { useState, useEffect, useCallback } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function useUpdateChecker() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [initialBuildTime, setInitialBuildTime] = useState(null);

  const checkForUpdate = useCallback(async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!res.ok) return;
      const { buildTime } = await res.json();

      if (!initialBuildTime) {
        setInitialBuildTime(buildTime);
      } else if (buildTime !== initialBuildTime) {
        setUpdateAvailable(true);
      }
    } catch {
      // Silently ignore fetch errors
    }
  }, [initialBuildTime]);

  useEffect(() => {
    // Initial fetch to capture the current build time
    checkForUpdate();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!initialBuildTime || updateAvailable) return;

    const interval = setInterval(checkForUpdate, CHECK_INTERVAL);

    // Also check when user returns to the tab
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') checkForUpdate();
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [initialBuildTime, updateAvailable, checkForUpdate]);

  const reload = () => window.location.reload();

  return { updateAvailable, reload };
}
